import BaseFooter from "./BaseFooter";

export default BaseFooter;
